<template>
  <div class="bg">
        <div class="loginBox">
            <van-form @submit="onSubmit">
                <van-field
                    v-model="modedata.name"
                    name="真实姓名"
                    label="真实姓名"
                    placeholder="输入真实姓名"
                />
                <van-field
                    readonly
                    clickable
                    name="picker"
                    :value="sexName"
                    label="选择性别"
                    placeholder="点击选择性别"
                    @click="showPicker = true"
                />
                <van-field
                    v-model="modedata.phone"
                    name="手机号"
                    label="手机号"
                    placeholder="输入手机号"
                />
                <van-field
                    readonly
                    clickable
                    name="picker"
                    :value="modedata.danwei"
                    label="选择单位"
                    placeholder="点击选择单位"
                    @click="showPicker2 = true"
                />
                <div style="margin: 16px;">
                    <van-button @click="addMsg" round block type="info" native-type="submit">提交</van-button>
                </div>
            </van-form>
        </div>

        <van-popup v-model="showPicker" position="bottom">
            <van-picker
                show-toolbar
                :columns="columns"
                @confirm="onConfirm1"
                @cancel="showPicker = false"
            />
        </van-popup>
        <van-popup v-model="showPicker2" position="bottom">
            <van-picker
                show-toolbar
                value-key='name'
                :columns="columns2"
                @confirm="onConfirm2"
                @cancel="showPicker = false"
            />
        </van-popup>
  </div>
</template>

<script>
import Vue from 'vue';
import { Form , Field ,Button,Picker,Popup} from 'vant';
import attrs, {requiredSelect,required, alpha_num, chs_phone } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import {addMsg,getCompany} from '@/api/user'
import cookie from "@utils/store/cookie";
Vue.use(Popup);
Vue.use(Picker);
Vue.use(Form);
Vue.use(Field);
Vue.use(Button);
export default {
    data(){
        return {
            modedata:{
                name:'',
                phone:'',
                danwei:'',
                sex:''
            },
            columns: ['男', '女'],
            columns2: [],
            showPicker: false,
            showPicker2: false,
        }
    },
    created(){
        this.getdata();
    },
    methods:{
        async addMsg(){
            let that = this;
            let {name,phone,danwei,sex} = this.modedata;
            try {
                await that
                .$validator({
                    name:[
                        required(required.message("真实姓名")),
                    ],
                    sex:[
                        requiredSelect(requiredSelect.message("性别")),
                    ],
                    phone: [
                        required(required.message("手机号码")),
                        chs_phone(chs_phone.message())
                    ],
                    danwei:[
                        requiredSelect(requiredSelect.message("单位")),
                    ],
                })
                .validate({name,sex,phone,danwei});
            } catch (e) {
                return validatorDefaultCatch(e);
            }
            addMsg(this.modedata).then(res=>{
                console.log(res.msg)
                that.$dialog.success(res.msg);
                setTimeout(() => {
                    that.$router.replace({ path: '/' });
                }, 1500);
            }).catch(res => {
                // that.$dialog.error(res.msg);
            });
        },
        getdata(){
            getCompany().then(res=>{
                console.log(res)
                this.columns2 = res.data.list;
            })
        },
        onConfirm1(e){
            this.modedata.sex = e =='男'?1:0;
            this.sexName = e;
            this.showPicker = false;
        },
        onConfirm2(e){
            console.log(e)
            this.modedata.danwei = e.name;
            this.showPicker2 = false;
        },
    }
};
</script>

<style scoped>
    .bg{
        position: fixed;
        width: 100%;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }
    .loginBox{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        background-color: #ffffff;
        width: 90%;
        padding: 0.2rem;
        border-radius: 0.2rem;
        box-shadow: 0 0 10px #34343434;
    }
</style>